import React from 'react';
import { useTranslation } from 'react-i18next';

import { checkMessageDropped, isMessageV2DTO } from 'support/helpers/transactions/transactions';
import { MessageDTO, MessageV2DTO } from 'support/types';
import { AlertSection } from 'components/Display/Alert';
import { Alert } from 'components/Display/Alert/Alert';

import { formatDroppedReason } from '../helpers';

type DroppedMessageAlertProps = {
  message?: MessageDTO | MessageV2DTO;
};

export function DroppedMessageAlert({ message }: DroppedMessageAlertProps) {
  const { t } = useTranslation();
  const isMessageDropped =
    (message && (isMessageV2DTO(message) ? message?.dropped_error_reasons : !message?.droppedErrorReasons)) ||
    checkMessageDropped(message);

  if (!message || !isMessageDropped) {
    return null;
  }

  const droppedMessageReasons = isMessageV2DTO(message) ? message.dropped_error_reasons : message.droppedErrorReasons;

  if (!droppedMessageReasons || (isMessageV2DTO(message) && !droppedMessageReasons.length)) {
    return null;
  }

  return (
    <Alert severity="neutral" withoutIcon fullWidth>
      {droppedMessageReasons?.map((context, index) => {
        const formatted = formatDroppedReason(context, t);

        return (
          <React.Fragment key={index}>
            <AlertSection severity="neutral" title={formatted.header}>
              {formatted.content}
            </AlertSection>
            {formatted.howToFix && (
              <AlertSection severity="neutral" title={t('transactions:show.sections.errors.card.howToFix')}>
                {formatted.howToFix}
              </AlertSection>
            )}
          </React.Fragment>
        );
      })}
    </Alert>
  );
}
